import { render, staticRenderFns } from "./ValueAddedTaxInfo.vue?vue&type=template&id=07c3aa34&scoped=true&"
import script from "./ValueAddedTaxInfo.vue?vue&type=script&lang=ts&"
export * from "./ValueAddedTaxInfo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07c3aa34",
  null
  
)

export default component.exports